import { Box, Button, Typography} from '@mui/material'
import React, { useState, useEffect }  from 'react'
import { useNavigate } from 'react-router-dom';
import ProjectCard from './Projects/ProjectCard';
import CreateNewProjectCardAnimated from './Projects/CreateNewProjectCardAnimated';
import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';



  const Dashboard = () => {
    const navigate = useNavigate();
    const { permissions } = useCurrentUser();

    const [projects, setProjects] = useState([]);
    const [models, setModels] = useState([]);

    useEffect(() => {
      const fetchProjetsAndModels = async () => {
        try {
          const [projRes, modelRes] = await Promise.all([
            axios.get('/projects'),
            axios.get('/models')
          ]);

          const sortedProjects = projRes.data.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setProjects(sortedProjects);

          const zooModels = modelRes.data
            .filter(m => m.in_model_zoo_public)
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          setModels(zooModels);
        } catch (err) {
          console.error(err);
        }
      };

      fetchProjetsAndModels();
    }, []);


  return (
      <Box sx={{
          mx: 'auto',
          mt: 1,
          position: 'relative',
          borderRadius: 4,
          overflow: 'hidden',
          width: { xs: '80%', sm: '70%' },
          display: 'flex',
          flexDirection: 'column', // ensure vertical stacking
          p: 1,
          }}
      >

      <Typography variant="h3" fontWeight={700} color='black' mt={4}>
        Dashboard
      </Typography>
      <Typography variant="h6" color="rgb(158, 151, 151)" mt={2}>
        Welcome back!
      </Typography>


      <Box mt={3}>
        <CreateNewProjectCardAnimated disabled={!permissions.includes('create_project')} />
        {/* <CreateNewProjectCard /> */}
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'row', mt: 4, gap: 2 }}>
        <Box sx={{ flex: 1, p: 2, borderRadius: 2}}>
          <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mt: 4, mb: 1 }}>
            Last Modified Projects
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 1 }}>
            Want a list of all your projects?
            <Button
              variant="text"
              sx={{ textTransform: 'none', color: '#00707c', fontSize: '1rem', fontWeight: 'bold'  }}
              onClick={() => navigate('/projects')}
            >
              Show all projects
            </Button>
          </Typography>

          <Box sx={{ display: 'flex', gap: 3, width: '100%', mt: 2 }}>
            {projects.slice(0, 2).map((project) => {
              // Find all models belonging to this project
              const projectModels = models.filter((m) => m.project_id === project.id);

              // Flatten test_images from all models
              const testImages = projectModels.flatMap((m) => m.test_images || []);

              // Pick the first one or fallback
              const imgSrc = testImages.length > 0 
                ? testImages[0] 
                : "/ModelTasks/InstanceSegmentation2.png";

              return (
                <ProjectCard
                  key={project.id}
                  img_src={imgSrc}
                  title={project.name}
                  date={new Date(project.created_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                  onClick={() => navigate(`/projects/${project.id}/info`)}
                  sx={{ flex: '1 1 0', height: '30vh' }}
                />
              );
            })}
          </Box>
        </Box>


        <Box sx={{ flex: 1, p: 2, borderRadius: 2 }}>
          <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mt: 4, mb: 1 }}>
            Last Uploaded Models
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 1 }}>
            Eager to see all the available models?
            <Button
              variant="text"
              sx={{ textTransform: 'none', color: '#00707c', fontSize: '1rem', fontWeight: 'bold' }}
              onClick={() => navigate('/model-zoo')}
            >
              Go to Model Zoo
            </Button>
          </Typography>

          <Box sx={{ display: 'flex', gap: 3, width: '100%', mt: 2}}>
            {models.slice(0, 2).map((model) => (
              <ProjectCard
                key={model.id}
                img_src={model.test_images?.[0] || "/ModelTasks/InstanceSegmentation.png"}
                title={model.name}
                date={new Date(model.created_at).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
                onClick={() => navigate(`/model-zoo`)}
                sx={{ flex: '1 1 0', height: '30vh' }}
              />
            ))}
          </Box> 
        </Box>
      </Box>
    </Box>
  )
}

export default Dashboard
